import React, {useState} from 'react';
import {useTheme} from '../../contexts/ThemeContext.tsx';
import {getAsaasSealUrl} from './membersAsaasSealUrl.ts';
import positiveSeal from './assets/asaas-servicos-financeiros-positivo.png';
import negativeSeal from './assets/asaas-servicos-financeiros-negativo.png';

export default function MembersAsaasSeal() {
  const {isDark} = useTheme();
  const [failed, setFailed] = useState<string[]>([]);
  const light = getAsaasSealUrl(process.env.REACT_APP_ASAAS_SEAL_LIGHT_URL);
  const remote = isDark ? getAsaasSealUrl(process.env.REACT_APP_ASAAS_SEAL_DARK_URL) || light : light;
  const local = isDark ? negativeSeal : positiveSeal;
  const src = remote && !failed.includes(remote) ? remote : local;
  return <div className="mt-6 flex flex-col gap-4 border-t border-[var(--members-border)] pt-5 sm:flex-row sm:items-center">
    <a href="https://asaas.com" target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 self-start rounded-lg sm:self-auto" aria-label="Serviços financeiros Asaas — abrir site em nova aba">
      {failed.includes(src) ? <span className="text-sm">Serviços financeiros Asaas</span> :
        <img src={src} alt="Serviços financeiros Asaas" width={752} height={275}
          className={`h-auto w-32 ${isDark && src === light ? 'rounded-lg bg-white p-2' : ''}`}
          onError={() => setFailed(values => [...values, src])} />}
    </a>
    <p className="members-secondary min-w-0 text-xs leading-relaxed">Os serviços financeiros e de pagamento são prestados pelo Asaas.</p>
  </div>;
}
